module.exports = __webpack_public_path__ + "static/media/Seviper_gaussian2.0adf802d.png";